<div>
  {{ translate('Tarjetas_de') }} {{ ciudadano?.nombre }} {{ ciudadano?.apellidos }}
</div>
<jqxGrid id="gridTarjetasAsignadas" #gridTarjetasAsignadas [theme]="environment.tema" [width]="'100%'" [height]="'45%'" [source]="adapterTarjetasAsignadas"
  [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true" [selectionmode]="'singlerow'" [columns]="columnsTarjetasAsignadas"
  [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="false" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
  [showaggregates]="true" [rowsheight]="25" [columnsheight]="25" [enabletooltips]="true" [groupable]="false" [editable]="true"
  (onRowclick)="onRowSelectAsignada($event)" (onCellendedit)="onCellEdit($event)">
</jqxGrid>

<div class="row" style="height: 10%; justify-content: center; display: flex;">
  <jqxButton style="float:left; margin-right: 25px;" [width]="25" [height]="25" [imgHeight]="15" [imgWidth]="15"
    [imgSrc]='"/assets/images/arriba.png"' [imgPosition]="'center'" (onClick)="associateTarjetasToCiudadano()" [disabled]="!(tarjetaLibreSelect)">
  </jqxButton>
  <jqxButton style="float:left; margin-left: 25px;" [width]="25" [height]="25" [imgHeight]="15" [imgWidth]="15"
    [imgSrc]='"/assets/images/abajo.png"' [imgPosition]="'center'" (onClick)="disassociateTarjetasFromCiudadano()" [disabled]="!(tarjetaAsignadaSelect)">
  </jqxButton>
</div>

<div>
  {{ translate("Tarjetas_libres") }}
</div>
<jqxGrid id="gridTarjetasLibres" #gridTarjetasLibres [theme]="environment.tema" [width]="'100%'" [height]="'45%'" [source]="adapterTarjetasLibres"
  [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true" [selectionmode]="'singlerow'" [columns]="columnsTarjetasLibres"
  [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="false" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
  [showaggregates]="true" [rowsheight]="25" [columnsheight]="25" [enabletooltips]="true" [groupable]="false" [editable]="false"
  (onRowclick)="onRowSelectLibre($event)">
</jqxGrid>

